module.exports = __WEBPACK_EXTERNAL_MODULE_60__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/Vector","root":["openfl","Vector"],"commonjs":"openfl/Vector","commonjs2":"openfl/Vector"}
// module id = 60
// module chunks = 0